import React, { useContext } from 'react'
import Modal from './Modal'
import { keyContext } from '../KeyContext'

function ManEventErrorModal({shown,errorText,zeroPriceError}) {
//   const clientHeight = shown ?  document.getElementById('tes').clientHeight : ''
//   // console.log(clientHeight)
  const {setEventErrorModal,setEventSaveObj} = useContext(keyContext)

  function handleOkBtn () {
        setEventErrorModal(false)
        setEventSaveObj()
    }
  return shown ? (
    <Modal open={shown}>
    
    <div style={{border:'1px solid white', width: '500px',height:'300px',backgroundColor:'white',padding:'20px',marginTop:'20px',borderRadius:'4px',position:'absolute',top:'50%',left:'50%',transform:'translate(-50%, -50%)'}}>
      
      <div style={{textAlign:'center',alignContent:'center',height:'170px'}}>
       {zeroPriceError}
       <br/>
      
       {errorText} 
       <button onClick={handleOkBtn} style={{backgroundColor:'#982f2f',color:'white',padding:'5px',width:'100px',borderRadius:'5px',position:'absolute',top:'55%',left:'40%'}}>Ok</button>
        </div>
      
    </div>
 
    </Modal>
  )
  : ''
}

export default ManEventErrorModal